import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import {
  reportFilterGroupState,
  reportHistoricState,
  reportSearchTypeState,
  reportViewState,
} from '../../../storage/reports';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { RouteReports } from '../../reports/routeReport/RouteReports';
import { RouteReportsByGroup } from '../../reports/routeReport/RouteReportsByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function RouteReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const groupId = useRecoilValue(reportFilterGroupState);
  const hasStates = !!useRecoilValue(reportHistoricState(groupId))?.states?.length;
  const isGroupReportView = reportSearchType === 1 && reportView === 0;

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            {!isGroupReportView && <RouteReports />}
            {isGroupReportView && <RouteReportsByGroup />}
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={isGroupReportView && hasStates ? 850 : 550}
    />
  );
}

export default RouteReportsPage;
